import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import { IPayload } from './../../models/ipayload'
import { IAction } from './../../models/iaction';
import { IEquipment } from '../../models/iequipment';
import { IEquipmentModel } from '../../models/iequipmentModel';
import { IEquipmentGroup } from '../../models/iequipmentGroup';
import { IPlace } from '../../models/iplace';
import { IAutocompleteOption } from '../../models/iautocompleteOption';
import { ICompany } from '../../models/icompany';
import { Reducer } from 'redux';
import { IEquipmentService } from '../../models/iequipmentService';
import { IArea } from '../../models/iarea';
import { orderBy } from 'lodash';
import { IServiceDraft } from './createService';

export interface IEquipmentState {
  equipments: IPayload<IEquipment>
  equipmentsFilter: any
  equipmentsByPlace: IPayload<IEquipment>
  equipmentsByPlaceFilter: any
  equipment: IEquipment
  loading: boolean
  loadingInfiniteScroll: boolean
  checkDelete: any
  searchTextEquipmentByPlace: string
  dataChangedForceReload: boolean
  equipmentModels: IPayload<IEquipmentModel>
  equipmentModelsLoading: boolean
  equipmentModel: IEquipmentModel,
  equipmentModelLoading: boolean,
  groups: IPayload<IEquipmentGroup>
  groupsLoading: boolean
  areas: IPayload<IArea>
  areasLoading: boolean
  place: IPlace
  placesLeafs: IPayload<IPlace>
  placesLoading: boolean
  companies: IPayload<ICompany>
  companiesLoading: boolean
  statusGlobal: string
  filters: {
    filteredModels: Array<IAutocompleteOption>,
    filteredPlaces: Array<IAutocompleteOption>,
    filteredGroups: Array<IAutocompleteOption>,
    filteredAreas: Array<IAutocompleteOption>,
    filteredCompanies: Array<IAutocompleteOption>,
    filteredStatus: {
      valid: boolean,
      invalid: {
        inDelay: boolean,
        notDone: boolean,
        hasNoServices: boolean,
        hasActionsOpenedOrOverdue: boolean,
        mixed: boolean,
      },
      maintenance: boolean,
      inactive: boolean
    },
    filterDeletedEquipments: boolean,
  },
  
  filtersByPlace: {
    filteredModels: Array<IAutocompleteOption>,
    filteredGroups: Array<IAutocompleteOption>,
    filteredAreas: Array<IAutocompleteOption>,
    filteredCompanies: Array<IAutocompleteOption>,
    filteredStatus: {
      valid: boolean,
      invalid: {
        inDelay: boolean,
        notDone: boolean,
        hasNoServices: boolean,
        hasActionsOpenedOrOverdue: boolean,
        mixed: boolean,
      },
      maintenance: boolean,
      inactive: boolean
    }
  }
  // To action timeline
  timelineActions: Array<IAction>,
  timelineActionsLoading: boolean,
  timelineActionsLoadingMoreData: boolean,
  timelineActionsCount: number,
  loadingDocument: boolean,
  attachmentFilesLoading: boolean,
  date: Date | null,
  loadingTimeline: boolean,
  timeline: any[],
  loadingZipExport: boolean,
  loadingSimplifiedExport: boolean,
  serviceDrafts: IServiceDraft[],
  serviceDraftsLoading: boolean,
  serviceDraftsCount: number,
  deleteServiceDraftLoading: boolean,
  deleteServiceDraftId: string,
}


const initialState: IEquipmentState = {
  equipments: { count: 0, rows: [] } as IPayload<IEquipment>,
  equipmentsByPlace: { count: 0, rows: [] } as IPayload<IEquipment>,
  equipmentsFilter: {},
  equipmentsByPlaceFilter: {},
  equipment: {} as IEquipment,
  loading: false,
  loadingInfiniteScroll: false,
  checkDelete: {},
  searchTextEquipmentByPlace: '',
  dataChangedForceReload: false, // utilizado para recarregar a pagina ao voltar para paramequipments caso vc tenha deletado ou mudado dados do equi
  // other collections
  equipmentModels: { count: 0, rows: [] } as IPayload<IEquipmentModel>,
  equipmentModelsLoading: false,
  equipmentModel: {} as IEquipmentModel,
  equipmentModelLoading: false,
  groups: { count: 0, rows: [] } as IPayload<IEquipmentGroup>,
  groupsLoading: false,
  areas: { count: 0, rows: [] } as IPayload<IArea>,
  areasLoading: false,
  place: {} as IPlace,
  placesLeafs: { count: 0, rows: [] } as IPayload<IPlace>,
  placesLoading: false,
  companies: { count: 0, rows: [] } as IPayload<ICompany>,
  companiesLoading: false,
  statusGlobal: '',

  // selected filters
  filters: {
    filteredModels: [] as Array<IAutocompleteOption>,
    filteredPlaces: [] as Array<IAutocompleteOption>,
    filteredGroups: [] as Array<IAutocompleteOption>,
    filteredAreas: [] as Array<IAutocompleteOption>,
    filteredCompanies: [] as Array<IAutocompleteOption>,
    filteredStatus: {
      valid: false,
      invalid: {
        inDelay: false,
        notDone: false,
        hasNoServices: false,
        hasActionsOpenedOrOverdue: false,
        mixed: false
      },
      maintenance: false,
      inactive: false
    },
    filterDeletedEquipments: false,
  },
  filtersByPlace: {
    filteredModels: [] as Array<IAutocompleteOption>,
    filteredGroups: [] as Array<IAutocompleteOption>,
    filteredAreas: [] as Array<IAutocompleteOption>,
    filteredCompanies: [] as Array<IAutocompleteOption>,
    filteredStatus: {
      valid: false,
      invalid: {
        inDelay: false,
        notDone: false,
        hasNoServices: false,
        hasActionsOpenedOrOverdue: false,
        mixed: false
      },
      maintenance: false,
      inactive: false
    }
  },
  //
  timelineActions: [] as Array<IAction>,
  timelineActionsLoading: false,
  timelineActionsLoadingMoreData: false,
  timelineActionsCount: 0,
  loadingDocument: false,
  attachmentFilesLoading: false,
  date: null,
  loadingTimeline: false,
  timeline: [],
  loadingZipExport: false,
  loadingSimplifiedExport: false,
  serviceDrafts: [],
  serviceDraftsLoading: false,
  serviceDraftsCount: 0,
  deleteServiceDraftLoading: false,
  deleteServiceDraftId: '',
};

const requestEquipmentsStart = (state: IEquipmentState, action: any): IEquipmentState => {
  return updateObject(state, { loading: true });
};
const requestEquipmentsInfiniteScrollStart = (state: IEquipmentState, action: any) => {
  return updateObject(state, { loadingInfiniteScroll: true });
};

const setEquipmentsFilter = (state: IEquipmentState, action: any) => {
  return updateObject(state, {
    equipmentsFilter: action.equipmentsFilter,
  });
};

const setEquipmentsByPlaceFilter = (state: IEquipmentState, action: any) => {
  return updateObject(state, {
    equipmentsByPlaceFilter: action.equipmentsFilter,
  });
};

const fetchEquipmentsSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, {
    equipments: action.equipments,
    loading: false
  });
};

const fetchEquipmentsByPlaceInfinteScrollSuccess = (state: IEquipmentState, action: any) => {
  const obj = { count: action.equipments.count, rows: [...state.equipmentsByPlace.rows, ...action.equipments.rows] }
  return updateObject(state, {
    equipmentsByPlace: obj,
    loadingInfiniteScroll: false
  });
};

const fetchEquipmentsByPlaceSuccess = (state: IEquipmentState, action: any) => {

  const equipmentsRowsSorted = orderBy(action.equipments.rows, ['equipmentModel.name'],['asc'])
  return updateObject(state, {
    equipmentsByPlace: {
      count: action.equipments.count,
      rows: equipmentsRowsSorted,
    },
    loading: false
  });
};

const fetchCompanyByIdSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, {
    equipment: action.equipment,
    loading: false
  });
}

const requestEquipmentsFail = (state: IEquipmentState, action: any) => {
  return updateObject(state, { loading: false });
};

const deleteEquipmentsSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, { loading: false });
}

const checkDeleteEquipmentsSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, {
    checkDelete: action.checkDelete,
    loading: false
  });
}

// restore deleted equipment
const revertDeletedEquipmentStart = (state: IEquipmentState, action: any): IEquipmentState => {
  return updateObject(state, { loading: true });
};

const revertDeletedEquipmentFail = (state: IEquipmentState, action: any) => {
  return updateObject(state, { loading: false });
};

const revertDeletedEquipmentSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, { loading: false });
}

const updateEquipmentsSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, { loading: false });
}

const inactivateEquipmentsSuccess = (state: IEquipmentState, action: any) => {
  const aux = [...state.equipments.rows]
  const ids = action.body.ids
  const inactivateBool = action.body.sendForInactivate ? true : false;
  const aux2 = [...state.equipmentsByPlace.rows];
  const equipmentById = state.equipment;

  if (Object.keys(equipmentById).length !== 0) {
    equipmentById.active = !inactivateBool;
    equipmentById.statusGlobal = inactivateBool === true ? 'inactive' : equipmentById.maintenance === true ? 'maintenance' : 'not defined';
  }

  ids.forEach((id: string) => {
    aux.forEach(equip => {
      if(equip._id === id) {
        equip.active = !inactivateBool;
        equip.statusGlobal = inactivateBool === true ? 'inactive' : equip.maintenance === true ? 'maintenance' : 'not defined';
      }
    });

    aux2.forEach(equip => {
      if(equip._id === id) {
        equip.active = !inactivateBool;
        equip.statusGlobal = inactivateBool === true ? 'inactive' : equip.maintenance === true ? 'maintenance' : 'not defined';
      }
    });
  })


  return updateObject(state, {
    equipments: {
      count: aux.length,
      rows: aux,
    },
    equipmentsByPlace: {
      count: aux2.length,
      rows: aux2,
    },
    loading: false
  });
}

const maintenanceEquipmentsSuccess = (state: IEquipmentState, action: any) => {
  const aux = [...state.equipments.rows]
  const ids = action.body.ids
  const maintenanceBool = action.body.sendForMaintenance ? true : false;
  const aux2 = [...state.equipmentsByPlace.rows];
  const equipmentById = state.equipment;

  if (Object.keys(equipmentById).length !== 0) {
    equipmentById.maintenance = maintenanceBool;
    equipmentById.statusGlobal = maintenanceBool === true ? 'maintenance' : 'not defined';
  }

  ids.forEach((id: string) => {
    aux.forEach(equip => {
      if(equip._id === id) {
        equip.maintenance = maintenanceBool;
        equip.statusGlobal = maintenanceBool === true ? 'maintenance' : 'not defined';
      }
    });
    aux2.forEach(equip => {
      if(equip._id === id) {
        equip.maintenance = maintenanceBool;
        equip.statusGlobal = maintenanceBool === true ? 'maintenance' : 'not defined';
      }
    });
  })

  return updateObject(state, {
    equipments: {
      count: aux.length,
      rows: aux,
    },
    equipmentsByPlace: {
      count: aux2.length,
      rows: aux2,
    },
    loading: false
  });
}

const deleteMultipleEquipmentsSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, { loading: false });
}

const postEquipmentsSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, { loading: false });
}

const setSearchTextEquipmentByPlace = (state: IEquipmentState, action: any) => {
  return updateObject(state, { searchTextEquipmentByPlace: action.searchText });
}

const setDataChangedForceReload = (state: IEquipmentState, action: any) => {
  return updateObject(state, { dataChangedForceReload: action.forceReload });
}

// selected filters
const filterEquipmentStatus = (state: IEquipmentState, action: any) => {
  return updateObject(state, { filters: { ...state.filters, filteredStatus: action.status } });
}

const filterEquipmentPlaces = (state: IEquipmentState, action: any) => {
  return updateObject(state, { filters: { ...state.filters, filteredPlaces: action.places }});
}

const filterEquipmentPlacesRemove = (state: IEquipmentState, action: any) => {
  let arr = [...state.filters.filteredPlaces];
  const filteredPlaces = arr.filter(place => place.value !== action.place.value)
  return updateObject(state, { filters: { ...state.filters, filteredPlaces } });
}

const filterEquipmentGroups = (state: IEquipmentState, action: any): IEquipmentState => {
  return updateObject(state, { filters: { ...state.filters, filteredGroups: action.groups } });
}

const filterEquipmentGroupsRemove = (state: IEquipmentState, action: any) => {
  let arr = [...state.filters.filteredGroups];
  const filteredGroups = arr.filter(group => group.value !== action.group.value)
  return updateObject(state, { filters: { ...state.filters, filteredGroups } });
}

const filterEquipmentAreas = (state: IEquipmentState, action: any): IEquipmentState => {
  return updateObject(state, { filters: { ...state.filters, filteredAreas: action.areas } });
}

const filterEquipmentAreasRemove = (state: IEquipmentState, action: any) => {
  let arr = [...state.filters.filteredAreas];
  const filteredAreas = arr.filter(area => area.value !== action.areas.value)
  return updateObject(state, { filters: { ...state.filters, filteredAreas } });
}

const filterEquipmentCompanies = (state: IEquipmentState, action: any): IEquipmentState => {
  return updateObject(state, { filters: { ...state.filters, filteredCompanies: action.companies } });
}

const filterEquipmentCompaniesRemove = (state: IEquipmentState, action: any) => {
  let arr = [...state.filters.filteredCompanies];
  const filteredCompanies = arr.filter(company => company.value !== action.companies.value)
  return updateObject(state, { filters: { ...state.filters, filteredCompanies } });
}

const filterEquipmentModels = (state: IEquipmentState, action: any) => {
  return updateObject(state, { filters: { ...state.filters, filteredModels: action.models } });
}

const filterEquipmentModelsRemove = (state: IEquipmentState, action: any) => {
  let arr = [...state.filters.filteredModels];
  const filteredModels = arr.filter(model => model.value !== action.model.value)
  return updateObject(state, { filters: { ...state.filters, filteredModels } });
}

const filterDeletedEquipments = (state: IEquipmentState, action: any): IEquipmentState => {
  return updateObject(state, { filters: { ...state.filters, filterDeletedEquipments: action.deletedEquipments } });
}

const filterDeletedEquipmentsRemove = (state: IEquipmentState, action: any) => {
  return updateObject(state, { filters: { ...state.filters, filterDeletedEquipments: false } });
}

const filterEquipmentClear = (state: IEquipmentState, action: any): IEquipmentState => {
  return updateObject(state, { filters: { filteredPlaces: [], filteredGroups: [], filteredAreas: [], filteredModels: [], filteredCompanies: [], filterDeletedEquipments: false, filteredStatus: {
    ...initialState.filters.filteredStatus,
    invalid: {
      ...initialState.filters.filteredStatus.invalid
  
    }
  }}});
}

// selected filters by place
const filterEquipmentByPlaceStatus = (state: IEquipmentState, action: any) => {
  return updateObject(state, { filtersByPlace: { ...state.filtersByPlace, filteredStatus: action.status } });
}

const filterEquipmentByPlaceGroups = (state: IEquipmentState, action: any): IEquipmentState => {
  return updateObject(state, { filtersByPlace: { ...state.filtersByPlace, filteredGroups: action.groups } });
}

const filterEquipmentByPlaceGroupsRemove = (state: IEquipmentState, action: any) => {
  let arr = [...state.filtersByPlace.filteredGroups];
  const filteredGroups = arr.filter(group => group.value !== action.group.value)
  return updateObject(state, { filtersByPlace: { ...state.filtersByPlace, filteredGroups } });
}

const filterEquipmentByPlaceAreas = (state: IEquipmentState, action: any): IEquipmentState => {
  return updateObject(state, { filtersByPlace: { ...state.filtersByPlace, filteredAreas: action.areas } });
}

const filterEquipmentByPlaceAreasRemove = (state: IEquipmentState, action: any) => {
  let arr = [...state.filtersByPlace.filteredAreas];
  const filteredAreas = arr.filter(area => area.value !== action.areas.value)
  return updateObject(state, { filtersByPlace: { ...state.filtersByPlace, filteredAreas } });
}

const filterEquipmentByPlaceCompanies = (state: IEquipmentState, action: any): IEquipmentState => {
  return updateObject(state, { filtersByPlace: { ...state.filtersByPlace, filteredCompanies: action.companies } });
}

const filterEquipmentByPlaceCompaniesRemove = (state: IEquipmentState, action: any) => {
  let arr = [...state.filtersByPlace.filteredCompanies];
  const filteredCompanies = arr.filter(company => company.value !== action.companies.value)
  return updateObject(state, { filtersByPlace: { ...state.filtersByPlace, filteredCompanies } });
}

const filterEquipmentByPlaceModels = (state: IEquipmentState, action: any) => {
  return updateObject(state, { filtersByPlace: { ...state.filtersByPlace, filteredModels: action.models } });
}

const filterEquipmentByPlaceModelsRemove = (state: IEquipmentState, action: any) => {
  let arr = [...state.filtersByPlace.filteredModels];
  const filteredModels = arr.filter(model => model.value !== action.model.value)
  return updateObject(state, { filtersByPlace: { ...state.filtersByPlace, filteredModels } });
}

const filterEquipmentByPlaceClear = (state: IEquipmentState, action: any): IEquipmentState => {
  return updateObject(state, { filtersByPlace: { ...initialState.filtersByPlace, filteredStatus: { ...initialState.filtersByPlace.filteredStatus, invalid: { ...initialState.filtersByPlace.filteredStatus.invalid }} } });
}

const setExpirationDateServiceEquipmentsCreateForm = (state: IEquipmentState, action: any): IEquipmentState => {
  const newExpiration = action.date;
  const serviceChanging = action.service;
  const isValid = action.isValid;

  const equipmentModel = { ...state.equipmentModel }

  const index = equipmentModel.equipmentServices.findIndex(service => service._id === serviceChanging._id)
  if (index > -1) {
    equipmentModel.equipmentServices[index].expiration = newExpiration
    equipmentModel.equipmentServices[index].isValid = isValid
  }

  return {
    ...state,
    equipmentModel
  }
}

const clearEquipmentsEquipmentModelsById = (state: IEquipmentState, action: any): IEquipmentState => {
  return {
    ...state,
    equipmentModel: {} as IEquipmentModel,
  }
}

// Other Collections

//Equipment Models

const requestEquipmentModelsStart = (state: IEquipmentState, action: any) => {
  return updateObject(state, { equipmentModelsLoading: true });
}

const fetchEquipmentModelsSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, { equipmentModelsLoading: false, equipmentModels: action.equipmentModels });
}

const requestEquipmentModelsFail = (state: IEquipmentState, action: any) => {
  return updateObject(state, { equipmentModelsLoading: false });
}

const requestEquipmentModelsByIdStart = (state: IEquipmentState, action: any) => {
  return updateObject(state, { equipmentModelLoading: true });
}

const fetchEquipmentModelsByIdSuccess = (state: IEquipmentState, action: any) => {
  action.equipmentModel.equipmentServices.forEach((services: IEquipmentService) => {
    services.expiration = null
  })

  return updateObject(state, { equipmentModelLoading: false, equipmentModel: action.equipmentModel });
}

const requestEquipmentModelsByIdFail = (state: IEquipmentState, action: any) => {
  return updateObject(state, { equipmentModelLoading: false });
}

// Groups

const requestGroupsStart = (state: IEquipmentState, action: any) => {
  return updateObject(state, { groupsLoading: true });
}

const fetchGroupsSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, { groupsLoading: false, groups: action.groups });
}

const requestGroupsFail = (state: IEquipmentState, action: any) => {
  return updateObject(state, { groupsLoading: false });
}

// Areas

const requestAreasStart = (state: IEquipmentState, action: any) => {
  return updateObject(state, { areasLoading: true });
}

const fetchAreasSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, { areasLoading: false, areas: action.areas });
}

const requestAreasFail = (state: IEquipmentState, action: any) => {
  return updateObject(state, { areasLoading: false });
}

// Places

const requestPlacesStart = (state: IEquipmentState, action: any): IEquipmentState => {
  return updateObject(state, { placesLoading: true });
}

const fetchPlacesSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, { placesLoading: false, placesLeafs: action.placesLeafs });
}

const requestPlacesFail = (state: IEquipmentState, action: any) => {
  return updateObject(state, { placesLoading: false });
}

const fetchPlaceByIdSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, { placesLoading: false, place: action.place });
}

// Companies

const requestCompaniesStart = (state: IEquipmentState, action: any): IEquipmentState => {
  return updateObject(state, { companiesLoading: true });
}

const fetchCompaniesSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, { companiesLoading: false, companies: action.companies });
}

const requestCompaniesFail = (state: IEquipmentState, action: any) => {
  return updateObject(state, { companiesLoading: false });
}

// Timeline

const fetchActionsByEquipmentStart = (state: IEquipmentState, action: any) => {
  return updateObject(state, { timelineActionsLoading: true });
}

const fetchMoreActionsByEquipmentStart = (state: IEquipmentState, action: any) => {
  return updateObject(state, { timelineActionsLoadingMoreData: true });
}

const fetchActionsByEquipmentSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(
    state,
    {
      timelineActionsLoading: false,
      timelineActions: action.timelineActions.rows,
      timelineActionsCount: action.timelineActions.count
    },
  );
}

const fetchMoreActionsByEquipmentSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(
    state,
    {
      timelineActionsLoadingMoreData: false,
      timelineActions: [...state.timelineActions, ...action.timelineActions.rows],
      timelineActionsCount: action.timelineActions.count
    },
  );
}

const fetchActionsByEquipmentFail = (state: IEquipmentState, action: any) => {
  return updateObject(state, { timelineActionsLoading: false });
}

const fetchMoreActionsByEquipmentFail = (state: IEquipmentState, action: any) => {
  return updateObject(state, { timelineActionsLoadingMoreData: false });
}

const setManufacturingDate = (state: IEquipmentState, action: any) => {
  return updateObject(state, { date: action.date });
}

// attachment files
const requestEquipmentAttachmentFileDocumentStart = (state: IEquipmentState, action: any) => {
  return updateObject(state, { loadingDocument: true });
}

const fetchEquipmentAttachmentFileByIdSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, {
    equipment: { ...state.equipment, attachments: action.attachments },
    loading: false,
    loadingDocument: false
  });
}

const requestEquipmentAttachmentFileDocumentFail = (state: IEquipmentState, action: any) => {
  return updateObject(state, { loadingDocument: false });
}

const fetchEquipmentTimelineStart = (state: IEquipmentState) => {
  return updateObject(state, { loadingTimeline: true })
}

const fetchEquipmentTimelineSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, { loadingTimeline: false, timeline: action.timeline })
}

const fetchEquipmentTimelineFail = (state: IEquipmentState) => {
  return updateObject(state, { loadingTimeline: false })
}

const fetchEquipmentServicesReplicatedZipStart = (state: IEquipmentState) => {
  return updateObject(state, { loadingZipExport: true })
}

const fetchEquipmentServicesReplicatedZipSuccessFail = (state: IEquipmentState) => {
  return updateObject(state, { loadingZipExport: false })
}

const fetchEquipmentServicesSimplifiedStart = (state: IEquipmentState) => {
  return updateObject(state, { loadingSimplifiedExport: true })
}

const fetchEquipmentServicesSimplifiedSuccessFail = (state: IEquipmentState) => {
  return updateObject(state, { loadingSimplifiedExport: false })
}

// Service Drafts

const fetchServiceDraftsStart = (state: IEquipmentState) => {
  return updateObject(state, { serviceDraftsLoading: true })
}

const fetchServiceDraftsSuccess = (state: IEquipmentState, action: any) => {
  return updateObject(state, { serviceDraftsLoading: false, serviceDrafts: action.serviceDrafts.rows, serviceDraftsCount: action.serviceDrafts.count})
}

const fetchServiceDraftsFail = (state: IEquipmentState) => {
  return updateObject(state, { serviceDraftsLoading: false })
}

const deleteDraftStart = (state: IEquipmentState, action: any) => {
  return updateObject(state, { deleteServiceDraftLoading: true, deleteServiceDraftId: action.payload })
}

const deleteDraftSuccess = (state: IEquipmentState) => {
  return updateObject(state, { deleteServiceDraftLoading: false, deleteServiceDraftId: '' })
}

const deleteDraftFail = (state: IEquipmentState) => {
  return updateObject(state, { deleteServiceDraftLoading: false, deleteServiceDraftId: '' })
}

const reducer: Reducer<IEquipmentState> = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.REQUEST_EQUIPMENTS_START: return requestEquipmentsStart(state, action);
    case actionTypes.REQUEST_EQUIPMENTS_BY_PLACE_INFINITE_SCROLL_START: return requestEquipmentsInfiniteScrollStart(state, action);

    case actionTypes.FETCH_EQUIPMENTS_SUCCESS: return fetchEquipmentsSuccess(state, action);
    case actionTypes.FETCH_EQUIPMENTS_BY_ID_SUCCESS: return fetchCompanyByIdSuccess(state, action);
    case actionTypes.FETCH_EQUIPMENTS_BY_PLACE_INFINITE_SCROLL_SUCCESS: return fetchEquipmentsByPlaceInfinteScrollSuccess(state, action);
    case actionTypes.FETCH_EQUIPMENTS_BY_PLACE_SUCCESS: return fetchEquipmentsByPlaceSuccess(state, action);

    case actionTypes.REQUEST_EQUIPMENTS_FAIL: return requestEquipmentsFail(state, action);
    case actionTypes.DELETE_EQUIPMENTS_SUCCESS: return deleteEquipmentsSuccess(state, action);
    case actionTypes.CHECK_DELETE_EQUIPMENTS_SUCCESS: return checkDeleteEquipmentsSuccess(state, action);
    case actionTypes.UPDATE_EQUIPMENTS_SUCCESS: return updateEquipmentsSuccess(state, action);
    case actionTypes.INACTIVATE_EQUIPMENTS_SUCCESS: return inactivateEquipmentsSuccess(state, action);
    case actionTypes.MAINTENANCE_EQUIPMENTS_SUCCESS: return maintenanceEquipmentsSuccess(state, action);
    case actionTypes.DELETE_MULTIPLE_EQUIPMENTS_SUCCESS: return deleteMultipleEquipmentsSuccess(state, action);
    case actionTypes.POST_EQUIPMENTS_SUCCESS: return postEquipmentsSuccess(state, action);
    case actionTypes.REVERT_DELETED_EQUIPMENT_START: return revertDeletedEquipmentStart(state, action);
    case actionTypes.REVERT_DELETED_EQUIPMENT_FAIL: return revertDeletedEquipmentFail(state, action);
    case actionTypes.REVERT_DELETED_EQUIPMENT_SUCCESS: return revertDeletedEquipmentSuccess(state, action);

    case actionTypes.SET_SEARCH_TEXT_EQUIPMENT_BY_PLACE: return setSearchTextEquipmentByPlace(state, action);
    case actionTypes.SET_DATA_CHANGED_FORCE_RELOAD: return setDataChangedForceReload(state, action);
    case actionTypes.SET_EQUIPMENTS_FILTER: return setEquipmentsFilter(state, action);
    case actionTypes.SET_EQUIPMENTS_BY_PLACE_FILTER: return setEquipmentsByPlaceFilter(state, action);
    case actionTypes.SET_EXPIRATION_DATE_SERVICE_EQUIPMENTS_CREATE_FORM: return setExpirationDateServiceEquipmentsCreateForm(state, action);
    case actionTypes.CLEAR_EQUIPMENTS_EQUIPMENT_MODELS_BY_ID: return clearEquipmentsEquipmentModelsById(state, action);

    // Fetch Filter AutoCompletes
    case actionTypes.EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_START: return requestEquipmentModelsStart(state, action);
    case actionTypes.EQUIPMENTS_FETCH_EQUIPMENT_MODELS_SUCCESS: return fetchEquipmentModelsSuccess(state, action);
    case actionTypes.EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_FAIL: return requestEquipmentModelsFail(state, action);

    case actionTypes.EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_BY_ID_START: return requestEquipmentModelsByIdStart(state, action);
    case actionTypes.EQUIPMENTS_FETCH_EQUIPMENT_MODELS_BY_ID_SUCCESS: return fetchEquipmentModelsByIdSuccess(state, action);
    case actionTypes.EQUIPMENTS_REQUEST_EQUIPMENT_MODELS_BY_ID_FAIL: return requestEquipmentModelsByIdFail(state, action);

    case actionTypes.EQUIPMENTS_REQUEST_GROUPS_START: return requestGroupsStart(state, action);
    case actionTypes.EQUIPMENTS_FETCH_GROUPS_SUCCESS: return fetchGroupsSuccess(state, action);
    case actionTypes.EQUIPMENTS_REQUEST_GROUPS_FAIL: return requestGroupsFail(state, action);

    case actionTypes.EQUIPMENTS_REQUEST_AREAS_START: return requestAreasStart(state, action);
    case actionTypes.EQUIPMENTS_FETCH_AREAS_SUCCESS: return fetchAreasSuccess(state, action);
    case actionTypes.EQUIPMENTS_REQUEST_AREAS_FAIL: return requestAreasFail(state, action);

    case actionTypes.EQUIPMENTS_REQUEST_PLACES_START: return requestPlacesStart(state, action);
    case actionTypes.EQUIPMENTS_FETCH_PLACES_LEAFS_SUCCESS: return fetchPlacesSuccess(state, action);
    case actionTypes.EQUIPMENTS_REQUEST_PLACES_FAIL: return requestPlacesFail(state, action);

    case actionTypes.EQUIPMENTS_FETCH_PLACES_BY_ID_SUCCESS: return fetchPlaceByIdSuccess(state, action);

    case actionTypes.EQUIPMENTS_REQUEST_COMPANIES_START: return requestCompaniesStart(state, action);
    case actionTypes.EQUIPMENTS_FETCH_COMPANIES_SUCCESS: return fetchCompaniesSuccess(state, action);
    case actionTypes.EQUIPMENTS_REQUEST_COMPANIES_FAIL: return requestCompaniesFail(state, action);

    // Filter
    case actionTypes.FILTER_EQUIPMENT_STATUS: return filterEquipmentStatus(state, action);
    case actionTypes.FILTER_EQUIPMENT_PLACES: return filterEquipmentPlaces(state, action);
    case actionTypes.FILTER_EQUIPMENT_PLACES_REMOVE: return filterEquipmentPlacesRemove(state, action);
    case actionTypes.FILTER_EQUIPMENT_GROUPS: return filterEquipmentGroups(state, action);
    case actionTypes.FILTER_EQUIPMENT_GROUPS_REMOVE: return filterEquipmentGroupsRemove(state, action);
    case actionTypes.FILTER_EQUIPMENT_AREAS: return filterEquipmentAreas(state, action);
    case actionTypes.FILTER_EQUIPMENT_AREAS_REMOVE: return filterEquipmentAreasRemove(state, action);
    case actionTypes.FILTER_EQUIPMENT_COMPANIES: return filterEquipmentCompanies(state, action);
    case actionTypes.FILTER_EQUIPMENT_COMPANIES_REMOVE: return filterEquipmentCompaniesRemove(state, action);
    case actionTypes.FILTER_EQUIPMENT_MODELS: return filterEquipmentModels(state, action);
    case actionTypes.FILTER_EQUIPMENT_MODELS_REMOVE: return filterEquipmentModelsRemove(state, action);
    case actionTypes.FILTER_EQUIPMENT_DELETEDEQUIPMENTS: return filterDeletedEquipments(state, action);
    case actionTypes.FILTER_EQUIPMENT_DELETEDEQUIPMENTS_REMOVE: return filterDeletedEquipmentsRemove(state, action);
    case actionTypes.FILTER_EQUIPMENT_CLEAR: return filterEquipmentClear(state, action);

    case actionTypes.FILTER_EQUIPMENT_BY_PLACE_STATUS: return filterEquipmentByPlaceStatus(state, action);
    case actionTypes.FILTER_EQUIPMENT_BY_PLACE_GROUPS: return filterEquipmentByPlaceGroups(state, action);
    case actionTypes.FILTER_EQUIPMENT_BY_PLACE_GROUPS_REMOVE: return filterEquipmentByPlaceGroupsRemove(state, action);
    case actionTypes.FILTER_EQUIPMENT_BY_PLACE_AREAS: return filterEquipmentByPlaceAreas(state, action);
    case actionTypes.FILTER_EQUIPMENT_BY_PLACE_AREAS_REMOVE: return filterEquipmentByPlaceAreasRemove(state, action);
    case actionTypes.FILTER_EQUIPMENT_BY_PLACE_COMPANIES: return filterEquipmentByPlaceCompanies(state, action);
    case actionTypes.FILTER_EQUIPMENT_BY_PLACE_COMPANIES_REMOVE: return filterEquipmentByPlaceCompaniesRemove(state, action);
    case actionTypes.FILTER_EQUIPMENT_BY_PLACE_MODELS: return filterEquipmentByPlaceModels(state, action);
    case actionTypes.FILTER_EQUIPMENT_BY_PLACE_MODELS_REMOVE: return filterEquipmentByPlaceModelsRemove(state, action);
    case actionTypes.FILTER_EQUIPMENT_BY_PLACE_CLEAR: return filterEquipmentByPlaceClear(state, action);


    // Timeline
    case actionTypes.FETCH_ACTIONS_BY_EQUIPMENT_START: return fetchActionsByEquipmentStart(state, action);
    case actionTypes.FETCH_MORE_ACTIONS_BY_EQUIPMENT_START: return fetchMoreActionsByEquipmentStart(state, action);
    case actionTypes.FETCH_ACTIONS_BY_EQUIPMENT_SUCCESS: return fetchActionsByEquipmentSuccess(state, action);
    case actionTypes.FETCH_MORE_ACTIONS_BY_EQUIPMENT_SUCCESS: return fetchMoreActionsByEquipmentSuccess(state, action);
    case actionTypes.FETCH_ACTIONS_BY_EQUIPMENT_FAIL: return fetchActionsByEquipmentFail(state, action);
    case actionTypes.FETCH_MORE_ACTIONS_BY_EQUIPMENT_FAIL: return fetchMoreActionsByEquipmentFail(state, action);
    case actionTypes.SET_EQUIPMENTS_MANUFACTURING_DATE: return setManufacturingDate(state, action);
    case actionTypes.EQUIPMENTS_FETCH_TIMELINE_START: return fetchEquipmentTimelineStart(state);
    case actionTypes.EQUIPMENTS_FETCH_TIMELINE_SUCCESS: return fetchEquipmentTimelineSuccess(state, action);
    case actionTypes.EQUIPMENTS_FETCH_TIMELINE_FAIL: return fetchEquipmentTimelineFail(state);

    // Attachment Files
    case actionTypes.REQUEST_EQUIPMENT_ATTACHMENTFILE_DOCUMENT_START: return requestEquipmentAttachmentFileDocumentStart(state, action);
    case actionTypes.REQUEST_EQUIPMENT_ATTACHMENTFILE_DOCUMENT_FAIL: return requestEquipmentAttachmentFileDocumentFail(state, action);
    case actionTypes.FETCH_EQUIPMENT_ATTACHMENTFILE_BY_ID_SUCCESS: return fetchEquipmentAttachmentFileByIdSuccess(state, action);

    //Zip equipmentSerivces
    case actionTypes.EQUIPMENTS_FETCH_SERVICES_REPLICATED_ZIP_START: return fetchEquipmentServicesReplicatedZipStart(state);
    case actionTypes.EQUIPMENTS_FETCH_SERVICES_REPLICATED_ZIP_SUCCESS: return fetchEquipmentServicesReplicatedZipSuccessFail(state);
    case actionTypes.EQUIPMENTS_FETCH_SERVICES_REPLICATED_ZIP_FAIL: return fetchEquipmentServicesReplicatedZipSuccessFail(state);

    //simplified equipmentSerivces
    case actionTypes.EQUIPMENTS_FETCH_SERVICES_SIMPLIFIED_START: return fetchEquipmentServicesSimplifiedStart(state);
    case actionTypes.EQUIPMENTS_FETCH_SERVICES_SIMPLIFIED_SUCCESS: return fetchEquipmentServicesSimplifiedSuccessFail(state);
    case actionTypes.EQUIPMENTS_FETCH_SERVICES_SIMPLIFIED_FAIL: return fetchEquipmentServicesSimplifiedSuccessFail(state);

    // Service Drafts
    case actionTypes.EQUIPMENTS_FETCH_SERVICE_DRAFTS_START: return fetchServiceDraftsStart(state);
    case actionTypes.EQUIPMENTS_FETCH_SERVICE_DRAFTS_SUCCESS: return fetchServiceDraftsSuccess(state, action);
    case actionTypes.EQUIPMENTS_FETCH_SERVICE_DRAFTS_FAIL: return fetchServiceDraftsFail(state);
    case actionTypes.EQUIPMENTS_DELETE_SERVICE_DRAFT_START: return deleteDraftStart(state, action);
    case actionTypes.EQUIPMENTS_DELETE_SERVICE_DRAFT_SUCCESS: return deleteDraftSuccess(state);
    case actionTypes.EQUIPMENTS_DELETE_SERVICE_DRAFT_FAIL: return deleteDraftFail(state);

    default: return state;
  }
};

export default reducer;
